export const MAX_TUTORIAL_PROGRESS_COMPLETED_IDS = 1024;

const MAX_TUTORIAL_ID_LENGTH = 128;
const TUTORIAL_ID_PATTERN = /^[a-z0-9]+(?:[._-][a-z0-9]+)*$/;

function isRecord(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function hasExactFields(value, expectedFields) {
  if (!isRecord(value)) return false;
  const actualFields = Object.keys(value).sort();
  const sortedExpected = expectedFields.slice().sort();
  return actualFields.length === sortedExpected.length
    && actualFields.every((field, index) => field === sortedExpected[index]);
}

export function isTutorialProgressId(value) {
  return typeof value === "string"
    && value.length <= MAX_TUTORIAL_ID_LENGTH
    && value.includes(".")
    && TUTORIAL_ID_PATTERN.test(value);
}

export function canonicalizeTutorialProgressCommandIds(value) {
  if (!Array.isArray(value) || value.length === 0) {
    throw new TypeError("Tutorial IDs must be a non-empty array.");
  }
  const ids = new Set();
  for (const tutorialId of value) {
    if (!isTutorialProgressId(tutorialId)) {
      throw new TypeError("Tutorial IDs must be feature-namespaced lowercase tokens.");
    }
    ids.add(tutorialId);
  }
  if (ids.size > MAX_TUTORIAL_PROGRESS_COMPLETED_IDS) {
    throw new RangeError("Too many tutorial IDs were supplied.");
  }
  return Object.freeze(Array.from(ids).sort());
}

export function decodeTutorialProgressEnabledState(value) {
  if (hasExactFields(value, ["kind"]) && value.kind === "missing") {
    return Object.freeze({ kind: "missing" });
  }
  if (
    !hasExactFields(value, ["kind", "completedIds"])
    || value.kind !== "ready"
    || !Array.isArray(value.completedIds)
    || value.completedIds.length > MAX_TUTORIAL_PROGRESS_COMPLETED_IDS
  ) {
    throw new TypeError("Tutorial progress state is invalid.");
  }
  let previousId = null;
  for (const tutorialId of value.completedIds) {
    if (
      !isTutorialProgressId(tutorialId)
      || (previousId !== null && previousId >= tutorialId)
    ) {
      throw new TypeError("Tutorial completed IDs must be sorted and unique.");
    }
    previousId = tutorialId;
  }
  return Object.freeze({
    kind: "ready",
    completedIds: Object.freeze(value.completedIds.slice()),
  });
}
